import { Box, Grid, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import KenLoader from '../../../../GlobalComponents/KenLoader';
import { getCOE } from '../../../../Utils/apiService';
import { COEData } from '../../../../interfaces/COE';
import COECard from '../../../COE/components/COECard';
import { useStyles } from '../styles';

const ViewAllCoe = () => {
  const classes = useStyles();
  const [coeData, setCoeData] = useState<COEData[]>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    Promise.all([getCOE()])
      .then(async ([coeRes]) => {
        if (coeRes?.status) {
          setCoeData(coeRes?.result);
        }
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Paper className={classes.paperContainer}>
          <Box>
            <Typography sx={{ fontSize: { xs: '15px', ultraHD: '20px' }, fontWeight: '500', mb: { xs: '18px', ultraHD: '24px' } }}>COE</Typography>
          </Box>
          <Grid container spacing={2} sx={{ pr: { xs: '0px', md: '18px', ultraHD: '24px' }, pb: '10px', height: 'auto', overflow: 'auto' }}>
            {coeData?.map((item, index) => (
              <Grid item xs={12} sm={4} md={6} lg={4} xxl={3} key={index}>
                <COECard cardData={item} path="resources" />
              </Grid>
            ))}
          </Grid>
        </Paper>
      )}
    </>
  );
};

export default ViewAllCoe;
